import { useMutation } from '@tanstack/react-query';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

export const useUpdateWatchTime = () =>
  useMutation({
    mutationFn: updateWatchTime,
  });

const updateWatchTime = async (progress: ContentUpdateProgress) => {
  try {
    await api.post<void>(
      apiConfig.routes.entertainment.content.watchTime,
      progress
    );
  } catch {
    await api.post<void>(
      apiConfig.routes.entertainment.content.watchTimePublic,
      progress
    );
  }
};

export type ContentUpdateProgress = {
  type: string;
  content_id: string;
  watch_progress: number;
  watch_total: number;
  origin: string;
  time: number;
  device_code?: string;
};
